import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const styles = {
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    deleteIcon: {
        width: 30,
        height: 30,
        marginLeft:5,
        marginRight:5,
        marginTop:10,
        //borderColor: '#ff0000',
        // borderWidth:1,
        //alignItems:'flex-end',
    },
    editIcon: {
        width:30,
        height: 30,
        marginLeft:5,
        marginRight:5,
        marginTop:10,
        //borderColor: '#ff0000',
        //borderWidth:1,
        //alignItems:'flex-end',
    },

    icon: {
        width:20,
        height: 20,
        marginRight:10
    },
};

let id = 0;
function createData(name, calories, fat, carbs, protein) {
    id += 1;
    return { id, name, calories, fat, carbs, protein };
}

const data = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];

//const { src, video } = this.props;

let editImage = "/static/images/pencil-2.png";
let beingEditImage = "/static/images/beingEdited2.png";

class DynamicTable extends React.Component {
//function AddressForm() {


    constructor(props) {
        super(props);
        this.headersList=[];
        this.localData=[]
        this.state = {
            age: '',
            name: 'hai',
            labelWidth: 0,
            //headerList:[]
        };
        //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
        this.deleteImageClick = this.deleteImageClick.bind(this);
        this.editImageClick = this.editImageClick.bind(this);

    }

    handleSubmit = () => {
        /*this.setState(state => ({
            activeStep: state.activeStep + 1,
        }));*/
    };

    getHeaderList(data){

        let returnHeaders= [];
        if(data != null) {
            if (data.length > 0) {
                var firstRow = data[0];
                returnHeaders = Object.keys(firstRow);
                console.log("My keys are " + returnHeaders.toString());
                //
                this.localData = data;
            }
        }

        return returnHeaders;
    }//End of  getHeaderList

/*
                                <TableCell>Dessert (100g serving)</TableCell>
                                <TableCell align="right">Calories</TableCell>
                                <TableCell align="right">Fat (g)</TableCell>
                                <TableCell align="right">Carbs (g)</TableCell>
                                <TableCell align="right">Protein (g)</TableCell>*/

    //this.setState({open: false});

    getASingleRow(data, numberOfItems){
        var returnArray=[];
        let i=0;
        let tempIndex=0;
        let numberOfColumns =  Object.keys(data).length;
        var tempImageSource = editImage;
        if (data.editMode){
            if (data.editMode == true) {
                tempImageSource = beingEditImage;
            }
        }
        returnArray.push(< TableCell   scope = "row" > <img  height={30} width={30} src={tempImageSource}  onClick={() =>this.editImageClick(data)} /> < /TableCell>);
        for (i=0; i<numberOfColumns; i++){

            returnArray.push(< TableCell align = "right" > {data[this.headersList[tempIndex++]]} < /TableCell>);

        }
        returnArray.push(< TableCell   scope = "row" > <img src={'/static/images/red-close-circle-outline.png'} onClick={()=> this.deleteImageClick(data)}/> < /TableCell>);


        return returnArray;

    }

    deleteImageClick(argData){

        //alert('delete was 1 called');
        this.props.onDelete(argData.id);

    }

    editImageClick(argData){
        //alert('edit was  1 called');
        const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
       if(argData.editMode){
           if(argData.editMode == true) {

               argData.editMode = false;
           }else{
               argData.editMode = true;
           }
       }else{
           argData.editMode = true;
       }

        this.props.onEdit(argData);
    }


    render() {
        const {classes, data} = this.props;
        this.headersList = this.getHeaderList(data);
        //this.setState({headerList: this.getHeaderList(data)});
        return (
            <Paper className={classes.root}>
                    <h2> Number of rows {this.localData.length} </h2>
                    <Table className={classes.table}>
                        <TableHead>

                            <TableRow>
                                < TableCell align = "right"  component = "th" scope = "row"> Edit < /TableCell>

                                {this.headersList.map(n => (<TableCell align="right">{n}</TableCell>))}

                                < TableCell align = "right" > Delete < /TableCell>
                            </TableRow>
                        </TableHead>


                        < TableBody >
                            {
                                this.localData.map((n, index) => {
                                    let tempIndex=0;
                                    let numberOfColumns =  Object.keys(n).length;
                                    return(
                                    < TableRow key = {n.id} >
                                        {this.getASingleRow(n,numberOfColumns)}

                                        {/*
                                            < TableCell   scope = "row" > <img src={require('../../images/pencil-2.png')} /> < /TableCell>
                                            < TableCell component = "th" scope = "row" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} + {numberOfColumns} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                            < TableCell align = "right" > {n[this.headersList[tempIndex++]]} < /TableCell>
                                                < TableCell   scope = "row" > <img src={require('../../images/pencil-2.png')} /> < /TableCell>
                                                */}
                                < /TableRow>
                                ) }
                            )
                            }
                        </TableBody>

                    < /Table>
            < /Paper>);
    }//end of render

}//end of class

DynamicTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DynamicTable);